import { render } from "./ObservationChat.vue?vue&type=template&id=74be614b"
import script from "./ObservationChat.vue?vue&type=script&lang=js"
export * from "./ObservationChat.vue?vue&type=script&lang=js"

import "./ObservationChat.vue?vue&type=style&index=0&id=74be614b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__